import React, { useContext } from "react";
import { GlobalContext } from "../../context/GlobalState";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import TitleBlock from "../TitleBlock";
import { useRouteMatch } from "react-router-dom";

const SidebarTitle = ({title, subtitle}) => {
  return (
    <div className={container}>
      <TitleBlock
        title={title}
        subtitle={subtitle}
        style="title-block"
      />
    </div>
  );
};

export default SidebarTitle;

const container = css`
  padding: ${boxStyles.desktopPadding};
  background-color: #4996e914;
  .page-name {
    color: ${colors.brandColor};
    font-size: ${textSizes.normal};
  }

  .title-block {
    padding: 0;
    margin: 0;
    align-items: flex-start;
    h1,
    p {
      padding: 0;
      margin: 0;
      text-align: left;
    }
  }
`;
